module.exports = __webpack_public_path__ + "static/onetower-sm-c1e3d7e94108e0d33be94d6e8855c176.jpg";